export default class BlogCategory {
  constructor() {
    this.init();
  }

  init() {
    var Articles = {
      sort: function(items) {
        items.show();
        $('.articles__inner').find('article.article-item').not(items).fadeOut(500);
      },
      showAll: function(items) {
        items.fadeIn(500);
      },
      doSort: function() {
        $('a', '#tags-sort').on('click', function() {

          var $a = $(this);
          $('a', '#tags-sort').removeClass('active');
          if (!$a.is('#all')) {
            var items = $('article[data-tags*="' + $.trim($a.data('tag')) + '"]', '.articles__inner');
            Articles.sort(items);
          } else {
            Articles.showAll($('article.article-item', '.articles__inner'));
          }
          $a.addClass('active');
        });
      }
    };

    Articles.doSort();
  }
}
